import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ConfiguracionDePago } from 'src/app/pago/models/ConfiguracionDePago.model';
import { NombreProducto } from 'src/app/pago/enums/NombreProducto.enum';
import { PagoFacade } from 'src/app/pago/services/pago-facade/pago.facade';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
})
export class SwitchComponent implements OnInit {
  @Input() control: FormControl;
  @Input() label: string;
  @Input() idInput: string;
  @Output() switchChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  productName: string;

  constructor(private pagoFacade: PagoFacade) {}

  ngOnInit(): void {
    this.subscribeToConfiguracionDePago();
  }

  subscribeToConfiguracionDePago() {
    this.pagoFacade.configuracionDePago$.subscribe(
      (configuracionDePago: ConfiguracionDePago) => {
        this.productName = NombreProducto[configuracionDePago.idProducto];
      }
    );
  }

  onChange(checked: boolean) {
    this.switchChange.emit(checked);
  }
}
